import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ChartModule } from 'primeng/chart';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import {MatSidenavModule} from '@angular/material/sidenav';
import {CarouselModule} from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import {CdkMenuModule} from '@angular/cdk/menu';
import { MatTabsModule } from '@angular/material/tabs';
// import { LottieLoaderComponent } from '../shared-module-files/components/lottie-loader/lottie-loader.component';
// import { LottiePoppperComponent } from '../shared-module-files/components/lottie-poppper/lottie-poppper.component';

export const ConstMaterial = [
  MatGridListModule,
  MatIconModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatSidenavModule,
  MatInputModule,
  FormsModule,
  MatAutocompleteModule,
  ReactiveFormsModule,
  MatRadioModule,
  MatSelectModule,
  MatSnackBarModule,
  MatBottomSheetModule,
  MatCheckboxModule,
  MatMenuModule,
  MatCardModule,
  ClipboardModule,
  MatSlideToggleModule,
  MatProgressSpinnerModule,
  MatSortModule,
  MatTableModule,
  MatTooltipModule,
  MatButtonModule,
  MatChipsModule,
  SlickCarouselModule,
  ChartModule,
  CdkAccordionModule,
  CarouselModule,
  ButtonModule,
  CdkMenuModule,
  MatTabsModule
  // LottieLoaderComponent,
  // LottiePoppperComponent
  
];
@NgModule({
  declarations: [],
  imports: [CommonModule, ...ConstMaterial],
  exports: [...ConstMaterial],
  providers:[
    {
      provide:MatDialogRef,
      useValue:{}
    },
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} }
  ]
})
export class ConstantMaterialModule {}
